import { ItemDataType } from "components/Tree/types";

const PINNED_SEPARATOR: ItemDataType = {
  type: "separator",
  label: "",
  value: "__pinned_separator__",
  children: null,
  hideExpand: true,
};

/**
 * Sorts tree nodes with pinned items at the top, separated by a divider.
 * Returns the original array if no pinned items exist.
 */
export const sortWithPinnedFirst = (
  nodes: ItemDataType[],
  pinnedSet: Set<string>
): ItemDataType[] => {
  if (!pinnedSet.size) {
    return nodes;
  }

  const pinnedNodes = nodes.filter(node =>
    pinnedSet.has(node.value as string)
  );
  const unpinnedNodes = nodes.filter(
    node => !pinnedSet.has(node.value as string)
  );

  if (!pinnedNodes.length) {
    return nodes;
  }

  if (!unpinnedNodes.length) {
    return pinnedNodes;
  }

  return [...pinnedNodes, PINNED_SEPARATOR, ...unpinnedNodes];
};
